export const signicatTheme = {
  globals: {
    name: 'Signicat',
    fontFamily:
      '"Nunito Sans",-apple-system,".SFNSText-Regular","San Francisco",BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Helvetica,Arial,sans-serif',
    fontFamilyHeadline:
      '"Nunito Sans",-apple-system,".SFNSText-Regular","San Francisco",BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Helvetica,Arial,sans-serif',
    bgColor: 'rgba(235, 235, 235, 1)',
    linkColor: 'rgba(67, 21, 128, 1)',
    linkColorHover: 'rgba(112, 39, 208, 1)',
    checkboxColor: 'rgba(67, 21, 128, 1)',
    checkboxColorActive: 'rgba(67, 21, 128, 1)',
  },
  container: {
    bgColor: '#FFFFFF',
    width: '100%',
    padding: '60px 80px 60px',
    borderRadius: '8px',
    border: '1px solid rgba(228, 228, 228, 1)',
    boxShadow:
      'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;',
    margin: '0 auto',
    color: '#505050',
  },
  documentCheckbox: {
    iconColor: 'rgba(65, 255, 209, 1)',
    iconHover: 'rgba(65, 255, 209, 0.6)',
    width: '100%',
    contentFontSize: '14px',
    margin: '20px',
  },
  icon: {
    color: 'rgba(67, 21, 128, 1)',
    colorHover: 'rgba(67, 21, 128, 1)',
    size: '32px',
    thickness: '0.2px',
  },
  otpInput: {
    width: '100%',
    columnGap: '10px',
    marginTop: '10px',
    marginBottom: '30px',
    inputHeight: '60px',
    inputBorder: '1px solid rgba(220, 220, 220, 1)',
    borderRadius: '8px',
    fontSize: '28px',
    focusColor: 'rgba(65, 255, 209, 1)',
    bgColor: 'rgba(250, 250, 250, 1)',
    focusBgColor: '#ffffff',
    fontColor: '#505050',
    loadingColor: 'rgba(42, 0, 98, 1)',
  },
  pdfViewer: {
    pageBackground: 'rgba(255, 255, 255, 1)',
    canvasWidth: '495',
    containerPadding: '',
    containerBorder: '1px solid rgba(235, 235, 235, 1)',
    navigationTop: '',
    navigationLeft: '',
    navigationRight: '',
    navigationBottom: '',
    navigationBgColor: 'rgba(202, 202, 202, 0.4)',
    navigationBorderRadius: '8px',
    navigationPadding: '8px',
    navigationBoxShadow:
      'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;',
    navigationButtonBgColor: 'rgba(67, 21, 128, 1)',
    navigationButtonBorder: '1px solid rgba(67, 21, 128, 1)',
    navigationButtonColor: 'rgba(255, 255, 255, 1)',
    navigationButtonBgColorHover: 'rgba(67, 21, 128, 0.8)',
    navigationButtonBorderHover: '1px solid rgba(67, 21, 128, 0.8)',
    navigationButtonColorHover: 'rgba(255, 255, 255, 1)',
    navigationButtonPadding: '0px 5px',
    navigationButtonColorDisabled: 'rgba(236, 223, 253, 1)',
    navigationButtonBgColorDisabled: 'rgba(119, 96, 149, 1)',
    navigationButtonBorderDisabled: '1px solid rgba(119, 96, 149, 1)',
    navigationSpacerColor: 'rgba(180, 180, 180, 1)',
    searchTop: '',
    searchLeft: '',
    searchRight: '',
    searchBottom: '',
    searchBgColor: 'rgba(202, 202, 202, 0.4)',
    searchBorderRadius: '8px',
    searchPadding: '8px',
    searchBoxShadow:
      'rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;',
    searchColor: 'rgba(42, 0, 98, 1)',
    searchFontSize: '',
    searchInputRadius: '8px',
    searchInputHeight: '',
    searchInputColor: '',
    searchInputBgColor: '',
    searchInputBgColorFocus: 'rgba(255, 255, 255, 1)',
    searchInputBorder: '1px solid rgba(210, 210, 210, 1)',
    searchInputFocusBorder: '1px solid rgba(210, 210, 210, 1)',
    searchInputFocusOutline: '2px solid rgba(65, 255, 209, 1)',
    searchInputPadding: '',
  },
  button: {
    bgColor: 'rgba(65, 255, 209, 1)',
    padding: '12px 36px',
    borderRadius: '32px',
    width: 'auto',
    border: '1px solid rgba(65, 255, 209, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(42, 0, 98, 1)',
    colorHover: 'rgba(42, 0, 98, 1)',
    bgColorHover: 'rgba(65, 255, 209, 0.6)',
    borderHover: '1px solid rgba(65, 255, 209, 0.6)',
    bgColorDisabled: 'rgba(196, 253, 239, 1)',
    borderDisabled: '1px solid rgba(196, 253, 239, 1)',
    colorDisabled: 'rgba(78, 179, 153, 1)',
    fontSize: '13px',
    fontWeight: '600',
  },
  buttonDisabled: {
    bgColor: 'rgba(196, 253, 239, 1)',
    padding: '12px 36px',
    borderRadius: '32px',
    width: 'auto',
    border: '1px solid rgba(196, 253, 239, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'rgba(78, 179, 153, 1)',
    colorHover: 'rgba(78, 179, 153, 1)',
    bgColorHover: 'rgba(196, 253, 239, 1)',
    borderHover: '1px solid rgba(196, 253, 239, 1)',
    fontSize: '13px',
    fontWeight: '600',
  },
  header: {
    color: '#505050',
    fontSize: '1.625rem',
    lineHeight: '2.25rem',
    fontSizeMobile: '1.25rem',
    lineHeightMobile: '1.9375rem',
    margin: '15px 0',
    textAlign: 'center',
    width: '100%',
  },
  selectInput: {
    borderRadius: '8',
    borderWidth: '1px',
    primary: 'rgba(65, 255, 209, 1)',
    primary25: 'rgba(65, 255, 209, 0.75)',
    primary50: 'rgba(65, 255, 209, 0.50)',
    primary75: 'rgba(65, 255, 209, 0.25)',
    danger: 'rgba(226,64,40,1)',
    dangerLight: 'rgba(226,64,40,0.5)',
  },
  symbol: {
    primary: 'rgba(67, 21, 128, 1)',
    secondary: 'rgba(255, 255, 255, 1)',
    tenary: 'rgba(235, 235, 235, 1)',
  },
  textInput: {
    bgColor: 'white',
    padding: '14px',
    borderRadius: '8px',
    border: '1px solid rgba(220, 220, 220, 1)',
    boxShadow: 'none',
    margin: '0',
    color: 'gray',
    colorFocus: 'black',
    bgColorFocus: 'white',
    borderFocus: '1px solid rgba(220, 220, 220, 1)',
    bgColorDisabled: 'silver',
    borderDisabled: 'gray',
    colorDisabled: 'white',
    fontSize: '14px',
    fontWeight: '400',
    outline: '2px solid rgba(65, 255, 209, 1)',
    errorColor: '#d91111',
  },
  brandBar: {
    bgColor: 'white',
    padding: '30px',
    margin: '0 0 30px 0',
    border: 'none',
    boxShadow: 'none',
    justifyContent: 'normal',
  },
  wrapXs2a: {
    fontFamily:
      '"Nunito Sans",-apple-system,".SFNSText-Regular","San Francisco",BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Helvetica,Arial,sans-serif',
    fontFamilyHeadline:
      '"Nunito Sans",-apple-system,".SFNSText-Regular","San Francisco",BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Helvetica,Arial,sans-serif',
    bgColor: '#FFFFFF',
    linkColor: 'rgba(67, 21, 128, 1)',
    linkColorHover: 'rgba(112, 39, 208, 1)',
    checkboxColor: 'rgba(67, 21, 128, 1)',
    checkboxColorActive: 'rgba(67, 21, 128, 1)',
    backButton: {
      borderColor: 'rgba(65, 255, 209, 1)',
      color: '#505050',
      colorHover: '#505050',
      disabled: 'silver',
    },
    input: {
      bgColor: 'white',
      padding: '14px',
      borderRadius: '8px',
      border: '1px solid rgba(220, 220, 220, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'gray',
      colorFocus: 'black',
      bgColorFocus: 'white',
      borderFocus: '1px solid rgba(220, 220, 220, 1)',
      bgColorDisabled: 'silver',
      borderDisabled: 'gray',
      colorDisabled: 'white',
      fontSize: '14px',
      fontWeight: '400',
      outline: '2px solid rgba(65, 255, 209, 1)',
      errorColor: '#d91111',
    },
    button: {
      bgColor: 'rgba(65, 255, 209, 1)',
      padding: '12px 36px',
      borderRadius: '32px',
      width: 'auto',
      border: '1px solid rgba(65, 255, 209, 1)',
      boxShadow: 'none',
      margin: '0',
      color: 'rgba(42, 0, 98, 1)',
      colorHover: 'rgba(42, 0, 98, 1)',
      bgColorHover: 'rgba(65, 255, 209, 0.6)',
      borderHover: '1px solid rgba(65, 255, 209, 0.6)',
      bgColorDisabled: 'rgba(196, 253, 239, 1)',
      borderDisabled: '1px solid rgba(196, 253, 239, 1)',
      colorDisabled: 'rgba(78, 179, 153, 1)',
      fontSize: '13px',
      fontWeight: '600',
    },
  },
  wrapKlarna: {
    bgColor: 'rgba(235, 235, 235, 1)',
  },
  wrapKontomatik: {
    bgColor: '#FFF',
    textColor: '#505050',
    borderColor: 'rgba(228, 228, 228, 1)',
    headerColor: '#505050',
    primaryColor: 'rgba(65, 255, 209, 1)',
    primaryReverseColor: 'rgba(42, 0, 98, 1)',
    secondaryColor: '#586374',
    mainHoverColor: 'rgba(42, 0, 98, 1)',
    mainHoverReverseColor: '#FFF',
    listHoverColor: '#F5F5F5',
    disabledColor: '#CED4DA',
    errorColor: '#BB0000',
    borderRadius: '8px',
    width: '100%',
    padding: '60px 80px 60px',
    boxShadow:
      'rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;',
    margin: '0 auto',
  },
  progressBar: {
    time: 180,
    secondChance: true,
    showCounter: true,
    height: '18px',
    margin: '40px 0 10px 0',
    padding: '0 20px',
    border: '1px solid rgba(220, 220, 220, 1)',
    borderRadius: '18px',
    background: 'white',
    barFill:
      'linear-gradient(90deg, rgba(65,255,209,0) 0%, rgba(65,255,209,1) 100%)',
    counterMargin: '20px 0',
    counterPadding: '0',
    counterFontSize: '24px',
    counterColor: 'rgba(67, 21, 128, 1)',
    infoMessageTextAlign: 'center',
    infoMessageFontSize: '12px',
    infoMessageMargin: '6px 0 0 0',
  },
  stepper: {
    borderColor: 'rgba(67, 21, 128, 1)',
    fontSizeTitle: '12px',
    fontSizeDesc: '10px',
  },
  loadingSpinner: {
    primary: 'rgba(67, 21, 128, 1)',
    bgColor: '#FBFBFB',
  },
  tabSwitcher: {
    borderBottom: '2px solid #dbdbdb',
    buttonColor: '#9b9b9b',
    buttonBorderBottom: '4px solid #2a0760',
    buttonColorActive: '#000',
  },
}
